import { Fragment, forwardRef, useEffect, useState } from 'react'
import {
    AddOfferField,
    getPrice,
    isAppearanceField,
    isRealPennedEnvelopeField,
    isMultiTouchField,
    isCYOProduct,
    isNotCustomizableFn,
    isNullFieldType,
    isServiceProduct,
    isStreetviewImageField,
    leadField,
    mappingListGroupField,
} from '../../helpers/slug'
import CheckBox from '../Inputs/Checkbox'
import ChooseModalField from '../Inputs/ChooseModalField'
import { DateInput } from '../Inputs/Date'
import { Fileupload } from '../Inputs/Fileupload'
import { ListBox } from '../Inputs/ListBox'
import MappingListGroup from '../Inputs/MappingListGroup'
import { PreDefinedInput } from '../Inputs/PreDefinedInput'
import { Text } from '../Inputs/Text'
import { Textarea } from '../Inputs/Textarea'
import Toggle from '../Inputs/Toggle'
import { _isLoggedIn, log } from '../../helpers/utils'
import ShouldLogin from '../Inputs/ShouldLogin'
import { ConditionalComponent } from './ConditionalComponent'
import { MultiTouchFieldsComponent } from './MultiTouchFieldsComponent'
import { nanoid } from 'nanoid'
import OpenModalField from '../Inputs/OpenModalField'
import OfferUpgradeField from '../Inputs/OfferUpgradeField'
import { MappingFileUpload } from '../Inputs/MappingFileUpload'
import { ComboBoxComponent } from '../Inputs/ComboBoxComponent'
import AppearanceSection from './AppearanceSection'

// @TODO
// Customizations by default off - true
// conditional Validations for attributes - done
// open modal on list option click - done
// stop postage field reset attributes values - done
// remove default value of customization when upload design is selected. - done

const ShowField = forwardRef(
    (
        {
            onSelect,
            product,
            multiTouchProducts,
            defaultCustomizationTemplate,
            templates_and_attributes,
            attributes,
            mailerKey,
            ...props
        },
        ref,
    ) => {
        const [value, setParentValue] = useState(null)
        const { item } = props
        const [id, setId] = useState(null)

        const values = props.getValues ? props.getValues() : {}
        const watchedValue = props.watch ? props.watch(item.name) : undefined

        // log2('is coming here', item.name)

        if (product) {
            const multiplier = props.getMultiPlier ? props.getMultiPlier() : 1
            props.price = getPrice(product, props.quantity, multiplier)
        }

        const itemIsServiceProduct = isServiceProduct(product)

        const isNotCustomizable =
            isNotCustomizableFn({ item, values, product, mailerKey }) &&
            !itemIsServiceProduct

        const shouldRenderSelectAsToggle =
            item.type === 'select' &&
            Array.isArray(item.options) &&
            item.options.length === 2 &&
            item.options[0] === 'No' &&
            (isStreetviewImageField(item) || isRealPennedEnvelopeField(item))

        props.reloadShowField = () => {
            setId(nanoid())
        }

        const handleSelect = (newValue) => {
            setParentValue(newValue)
            if (onSelect) {
                onSelect(item, newValue)
            }
        }

        useEffect(() => {
            setId(nanoid())
            return () => {
                setId(null)
            }
        }, [])

        useEffect(() => {
            if (item.type === 'select' && watchedValue !== value) {
                setParentValue(watchedValue || null)
            }
        }, [item.type, value, watchedValue])

        if (
            isNullFieldType({
                item,
                product,
                attributes,
                values,
                mailerKey,
                ...props,
            })
        ) {
            if (item.name.includes('Select Template')) {
                log('showField', item)
            }
            return null
        }

        if (item?.isAttribute && isAppearanceField(item)) {
            return null
        }

        if (item?.shouldLoggedin && !_isLoggedIn()) return <ShouldLogin />

        props['product'] = product

        return (
            <Fragment key={id}>
                {isNotCustomizable ? (
                    <PreDefinedInput
                        defaultCustomizationTemplate={
                            defaultCustomizationTemplate
                        }
                        product={product}
                        ref={ref}
                        {...props}
                    />
                ) : item.type === 'choose-modal' ? (
                    <ChooseModalField
                        templates_and_attributes={templates_and_attributes}
                        ref={ref}
                        {...props}
                    />
                ) : item.type === 'toggle' ? (
                    <Toggle ref={ref} {...props} />
                ) : item.type === 'appearance-section' ? (
                    <AppearanceSection ref={ref} {...props} />
                ) : item.type === 'section-label' ? (
                    <div className="mt-[18px] mb-2 text-xs font-semibold uppercase tracking-[0.04em] text-gray-500">
                        {item.label}
                    </div>
                ) : item?.name?.includes(AddOfferField.name) ? (
                    <OfferUpgradeField ref={ref} {...props} />
                ) : shouldRenderSelectAsToggle ? (
                    <Toggle ref={ref} {...props} />
                ) : item.type === mappingListGroupField.type ? (
                    itemIsServiceProduct ? (
                        <MappingFileUpload ref={ref} {...props} />
                    ) : (
                        <MappingListGroup ref={ref} {...props} />
                    )
                ) : item.type === leadField.type ? (
                    <MappingFileUpload ref={ref} {...props} />
                ) : item.type === 'open-modal' ? (
                    <OpenModalField
                        key={'open-modal'}
                        ref={ref}
                        {...props}
                        templates_and_attributes={templates_and_attributes}
                    />
                ) : // <OpenModalField
                //     key={'open-modal'}
                //     ref={ref}
                //     {...props}
                //     templates_and_attributes={templates_and_attributes}
                // />
                // ) : item.type === 'leadupload' ? (
                //     <MappingFileUpload ref={ref} {...props} />
                item.type === 'checkbox' ? (
                    <CheckBox ref={ref} {...props} />
                ) : item.type === 'fileupload' ? (
                    <Fileupload ref={ref} list={'true'} {...props} />
                ) : item.type === 'select' ? (
                    <>
                        <ListBox setParentValue={handleSelect} {...props} />
                        {value && (
                            <ConditionalComponent
                                key={value}
                                templates_and_attributes={
                                    templates_and_attributes
                                }
                                mailerKey={mailerKey}
                                parentValue={value}
                                {...props}
                            />
                        )}
                        {value &&
                            (props.isThisMultiTouchProduct ||
                            isCYOProduct(product)
                                ? /^Mailer Type \d+$/.test(item.name)
                                : isMultiTouchField(item)) && (
                                <MultiTouchFieldsComponent
                                    parentValue={value}
                                    onSelect={onSelect}
                                    mailerKey={mailerKey}
                                    multiTouchProducts={multiTouchProducts}
                                    {...props}
                                />
                            )}
                    </>
                ) : item.type === 'date' ? (
                    <DateInput ref={ref} {...props} />
                ) : item.type === 'textarea' ? (
                    <Textarea ref={ref} {...props} />
                ) : item.type === 'combo' ? (
                    <ComboBoxComponent
                        setParentValue={handleSelect}
                        {...props}
                    />
                ) : item.type === 'sample-lead-list-info' ? (
                    ''
                ) : (
                    <Text ref={ref} {...props} />
                )}
            </Fragment>
        )
    },
)

ShowField.displayName = 'ShowField'

export { ShowField }
